import { render, staticRenderFns } from "./OffCanvasMenu.vue?vue&type=template&id=35e930e2&lang=html&"
import script from "./OffCanvasMenu.vue?vue&type=script&lang=js&"
export * from "./OffCanvasMenu.vue?vue&type=script&lang=js&"
import style0 from "./OffCanvasMenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports